const config = {
    'supAnnoList': {
        'bigData-btn-search': '通知公告,,,通知公告-查询'
    },
    'myBidding': {
        'bigData-btn-search': '招标管理,我的投标,,我的投标-查询'
    },
    'tenderCost': {
        'bigData-btn-search': '招标管理,投标费用,,投标费用-查询'
    },
    'dayAssessHead': {
        'bigData-btn-search': '绩效管理,日常考核,,日常考核-查询'
    },
    'workTask': {
        'bigData-btn-search': '绩效管理,整改任务,,整改任务-查询'
    },
    'workMonthly': {
        'bigData-btn-search': '绩效管理,月度考核,,月度考核-查询'
    }
};
export default config;